// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"earphone"},"nodeName":"g","children":[{"attributes":{"id":"fill1"},"nodeName":"g","children":[{"attributes":{"fill":"transparent","d":"M3 14C6 14 6 14 6 14C7.10457 14 8 14.8954 8 16V18C8 19.1046 7.10457 20 6 20H3V14Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"transparent","d":"M16 16C16 14.8954 16.8954 14 18 14H21V20H18C16.8954 20 16 19.1046 16 18V16Z"},"nodeName":"path","children":[]}]},{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M3 20V12.0667C3 7.05929 7.02944 3 12 3C16.9706 3 21 7.05929 21 12.0667V20M3 20H6C7.10457 20 8 19.1046 8 18V16C8 14.8954 7.10457 14 6 14C6 14 6 14 3 14V20ZM21 20V14H18C16.8954 14 16 14.8954 16 16V18C16 19.1046 16.8954 20 18 20H21Z","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-earphone')
export default class EarphoneIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'earphone',
    }
  }
}
